import './EsEmptyState.css';

/**
 * The one empty state: a muted icon in a ring over the sentence, centered in the room it is
 * given (Tim, 2026-10-22: "these messages are tiny and too top left"). The ring is the turn
 * strip's hourglass (EsGame.css, gameActionsTurnWait). size="screen" fills a screen or a page's
 * body below its toolbar and centers both ways; size="panel" sits centered inside a card or a
 * list's place. The text comes in as children, so each copykey stays at its call site.
 */
export function EsEmptyState( { icon, size = 'panel', role, className = '', textTestId, children, 'data-testid': dataTestId } ) {
    return (
        <div className={ ( 'esEmptyState ' + className ).trim() } data-size={ size } role={ role } data-testid={ dataTestId }>
            { icon &&
                <span className="esEmptyStateRing" aria-hidden="true">
                    <i className={ 'pi ' + icon } />
                </span> }
            <p className="esEmptyStateText" data-testid={ textTestId }>{ children }</p>
        </div>
    );
}
